import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  img {
    max-width: 100%;
  }
`


export const Probability_Desktop = ({
  annotations,
}: {
  annotations?: React.ReactNode[]
}) => {
  return (
    <Wrapper>
      <img src={require('./probabality_desktop.png')} />
      {annotations &&
        annotations.map((anno) => {
          return <>{anno}</>
        })}
    </Wrapper>
  )
}
